import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, SimpleGrid, Spinner } from '@chakra-ui/react';
import { usePerksContext } from '@src/components/sco/Perks/Layout/PerksContext';
import { PartnerCard } from '@src/components/sco/Perks/PartnerCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
type PartnerListProps = {
  keywords?: string;
};
export const PartnerList = t0 => {
  const $ = _c(13);
  const perksContext = usePerksContext();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = gql`
    query {
      benefits(orderBy: priority_DESC) {
        id
        name
        slug
        priority
        valueDescription
        redemptionUrl
        redemptionCode
        teaser
        tagline
        cardImage {
          id
          url
        }
        categories {
          id
          slug
          name
          icon {
            id
            url
          }
        }
      }
    }
  `;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const query = useQuery(t1);
  let t2;
  if ($[1] !== perksContext) {
    t2 = () => {
      perksContext.setBreadcrumbs([{
        title: "Perks",
        href: "/perks"
      }, {
        title: "Partners",
        href: "/perks/partners"
      }]);
      perksContext.setActiveSection("partners");
    };
    $[1] = perksContext;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== query.data) {
    t3 = [query.data];
    $[3] = query.data;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useUniversalEffect(t2, t3);
  if (query.loading || !query.data) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Center><Spinner /></Center>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t4;
  if ($[6] !== getBreakpointValue) {
    t4 = getBreakpointValue([1, 1, 2, 3]);
    $[6] = getBreakpointValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== query.data?.benefits) {
    t5 = query.data?.benefits?.map(_temp);
    $[8] = query.data?.benefits;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <><SimpleGrid columns={t4} gap={5}>{t5}</SimpleGrid></>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(benefit) {
  return <PartnerCard key={benefit.id} benefit={benefit} />;
}